import { Anchor, Group, Stack, Text } from "@mantine/core";
import { Link } from "@remix-run/react";
import {
  abbrName,
  formatPlayerName,
  getCurrentSquad,
} from "#app/utils/players.ts";
import { type PlayerResult } from "../routes/latest";
import { AvatarProxy } from "./image-proxy";
import { TeamBadge } from "./team-badge";

type Props = {
  player: PlayerResult;
  position: string;
  aslink?: boolean;
  abbr?: boolean;
  size?: "sm" | "lg";
};

export function PlayerHeader({
  player,
  position,
  size = "sm",
  aslink = false,
  abbr = false,
}: Props) {
  const squad = getCurrentSquad(player);
  if (!squad) {
    return null;
  }
  const { team } = squad;
  const playerName = formatPlayerName(player);
  const formattedName = abbr ? abbrName(playerName) : playerName;

  const imgSize = size === "lg" ? 100 : 60;
  const textSize = size === "lg" ? "lg" : "md";

  return (
    <Group wrap="nowrap">
      <AvatarProxy
        src={player.photo}
        size={imgSize}
        radius="xs"
        alt={playerName}
      />
      <Stack gap={0}>
        {aslink ? (
          <Anchor
            component={Link}
            to={`/players/player/${player.id}`}
            c="unset"
            fw={700}
            onClick={(event) => event.stopPropagation()}
          >
            {formattedName}
          </Anchor>
        ) : (
          <Text size={textSize} fw={700}>
            {formattedName}
          </Text>
        )}

        {team && <TeamBadge name={team.name} logo={team.logo} size={size} />}
        <Text size={textSize} variant="italic">
          {position}
        </Text>
      </Stack>
    </Group>
  );
}
